import { getRangeValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'elevatorsHasService' as const;

export const elevatorsHasServiceTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const hasElevatorsService = getRangeValue('lift_service')(jsonQuery);

    return hasElevatorsService ? [{ label: 'Есть грузовой лифт', value: createTagValue(ID) }] : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['lift_service'])(jsonQuery),
};
